import { chuHienTai } from './theo-nganh.ts'

/** Chuỗi của Pha C: sổ tiền, két, hoá đơn, hoa hồng, bảng lương, việc của KTV. Tiếng Việt có dấu. */
export const S = {
  nav: 'Sổ tiền',
  page: 'Sổ tiền',
  tabTongQuan: 'Hôm nay',
  tabHoaDon: 'Hoá đơn',
  tabKet: 'Két',
  // KH-GĐ2 7.2.5: hoá đơn bị huỷ, theo ngày huỷ.
  tabHuy: 'Bị huỷ',
  huyRong: 'Ngày này không có hoá đơn nào bị huỷ',
  huyRongPhu: 'Hoá đơn bị huỷ hiện ở đây theo ngày huỷ, kèm người huỷ và lý do.',
  huyLuc: (gio: string, ai: string | null) => `Huỷ ${gio}${ai === null ? '' : ` · ${ai}`}`,
  thuLuc: (ngayGio: string, ai: string | null) =>
    `Đã thu ${ngayGio}${ai === null ? '' : ` · ${ai}`}`,
  huyLyDoDong: (s: string) => `Lý do: ${s}`,
  thuLai: (so: string, tien: string) => `Thu lại: ${so} · ${tien}`,
  thuLaiCungHuy: 'hoá đơn này cũng đã huỷ',
  chuaThuLai: 'Chưa thu lại',
  truoc: 'Ngày trước',
  sau: 'Ngày sau',

  // Tổng quan (chủ tiệm)
  tienVao: 'Tiền vào',
  tienVaoPhu: 'thu tại quầy (dịch vụ + sản phẩm) + bán gói + nạp ví + tiền cọc',
  trongDoSanPham: (tien: string) =>
    `Sản phẩm đã bán hôm nay: ${tien} (tính theo hoá đơn, kể cả phần khách trả bằng ví)`,
  cach: {
    cash: 'Tiền mặt',
    transfer: 'Chuyển khoản',
    card: 'Quẹt thẻ',
    wallet: 'Trừ ví',
    deposit: 'Trừ cọc',
    mixed: 'Nhiều cách',
    none: 'Trừ gói / ví / cọc',
  } as Record<string, string>,
  banGoi: 'Bán gói',
  napVi: 'Nạp ví',
  viNote: 'Trừ ví không tính vào tiền vào — tiền đó khách đã nạp từ trước.',
  viDong: (tien: string) => `Trừ ví ${tien} không tính vào tiền vào vì khách đã nạp từ trước.`,
  nhanCoc: 'Tiền cọc (đã trừ hoàn cọc)',
  // RETRO M4: từng dòng cọc chuyển khoản — chủ tiệm dò với sao kê ngân hàng.
  cocCkTitle: 'Cọc chuyển khoản — dò với sao kê',
  // KH-GĐ2 5.1: tiền khách chuyển khoản lúc thu — nội dung "TT <mã lịch>" trên sao kê.
  thuCkTitle: 'Chuyển khoản lúc thu — dò với sao kê',
  thuCkPhu: 'Mỗi dòng phải có trong sao kê ngân hàng của tiệm (nội dung “TT mã lịch”).',
  cocCkPhu: 'Quầy tự ghi “đã nhận”. Mỗi dòng phải có trong sao kê ngân hàng của tiệm.',
  cocCkLoai: { received: 'Nhận', refunded: 'Hoàn', reversal: 'Sửa ghi nhầm' } as Record<
    string,
    string
  >,
  cocCkNguoi: (ten: string | null) => ten ?? 'Không rõ',
  cocDong: (tien: string) => `Trừ cọc ${tien} không tính vào tiền vào vì đã tính lúc nhận cọc.`,
  lich: 'Lịch hẹn cả tiệm',
  lichDong: (xong: number, tong: number, khongDen: number) =>
    // Trong mỗi vế là khoảng trắng KHÔNG NGẮT (U+00A0): vế không bị bẻ đôi ("0 / không đến", ui-critic v25).
    `${xong}/${tong}\u00A0đã\u00A0xong · ${khongDen}\u00A0không\u00A0đến`,
  /** Hai cụm của `lichDong` cho `CacCum` (dấu "·" không mồ côi cuối / đầu dòng — vòng 48). */
  lichDongCum: (xong: number, tong: number, khongDen: number): [string, string] => [
    `${xong}/${tong}\u00A0đã\u00A0xong`,
    `${khongDen}\u00A0không\u00A0đến`,
  ],
  giamGia: 'Đã giảm giá',
  hoaDonHuy: (n: number) => `${n} hoá đơn đã huỷ`,
  hoaHongThang: 'Hoa hồng tháng này',
  chuaCoHoaHong: 'Chưa có hoa hồng nào tháng này.',
  soDichVu: (n: number) => `${n}\u00A0dịch vụ`,

  // Hoá đơn
  chuaCoHoaDon: 'Ngày này chưa có hoá đơn nào.',
  chuaCoHoaDonPhu: 'Hoá đơn tự sinh khi lễ tân bấm "Xong" và thu tiền.',
  daHuy: 'Đã huỷ',
  khachLe: 'Khách lẻ',
  thuNgan: (ai: string) => `thu ngân ${ai}`,
  tamTinh: 'Tạm tính',
  giam: (lyDo: string) => `Giảm giá (${lyDo})`,
  tong: 'Tổng',
  traBang: 'Đã trả bằng',
  truGoi: 'trừ buổi gói',
  huyHoaDon: 'Huỷ hoá đơn',
  huyTitle: 'Huỷ hoá đơn',
  huyGiaiThich:
    'Hệ thống trả lại đủ: tiền, ví, buổi gói, hoa hồng. Hoá đơn vẫn nằm trong sổ với dấu "Đã huỷ".',
  huyLyDo: 'ví dụ: thu nhầm khách',
  huyNut: 'Huỷ hoá đơn này',
  giuLai: 'Giữ lại',
  daHuyXong: (so: string) => `Đã huỷ hoá đơn ${so}`,
  // KH-GĐ2 5.2 (money-auditor N4): huỷ hoá đơn có bo → nhắc, thu lại thì nhập lại bo.
  daHuyBo: (ds: string) => `Tiền bo đã bị bỏ theo: ${ds}. Thu lại thì nhớ nhập lại tiền bo.`,
  boDong: (ten: string, tien: string) => `${ten} ${tien}`,
  thuCkBo: (cach: string | undefined) => (cach === 'card' ? 'tiền bo quẹt thẻ' : 'tiền bo'),
  lyDoHuy: (lyDo: string) => `Lý do huỷ: ${lyDo}`,

  // Két
  ketTitle: 'Tiền mặt trong két',
  ketTuDau: 'từ đầu ngày',
  ketTuLanChot: (luc: string) => `từ lần chốt ${luc}`,
  // QĐ 02/10 #12: lần chốt đầu chỉ tính từ 0 giờ hôm nay — nói rõ để chủ tiệm không ngạc nhiên vì số lệch.
  ketTuDauLanDau: 'từ 0 giờ hôm nay (lần chốt đầu)',
  ketLanDauDem:
    'Lần chốt đầu: chỉ đếm tiền thu từ 0 giờ hôm nay. Tiền có sẵn trong két từ trước thì để riêng, không đếm vào.',
  ketCanCo: 'Két cần có',
  ketDauKy: 'Tiền để lại từ lần chốt trước',
  ketDauKyBoi: (ai: string) => `Tiền ${ai} để lại lần chốt trước`,
  ketThuDichVu: 'Thu tại quầy bằng tiền mặt (dịch vụ + sản phẩm)',
  ketBanGoi: 'Bán gói bằng tiền mặt',
  ketNapVi: 'Nạp ví bằng tiền mặt',
  ketHoanVi: 'Trả lại khách (hoàn ví)',
  ketHoanGoi: 'Trả lại khách (hoàn gói)',
  ketNhanCoc: 'Nhận cọc bằng tiền mặt',
  ketHoanCoc: 'Trả lại khách (hoàn cọc)',
  ketTraBo: 'Trả tiền bo cho thợ',
  ketChi: 'Khoản chi trả bằng tiền mặt',
  ketDem: 'Đếm được trong két',
  ketDemGoiY: 'ví dụ 3.450.000',
  ketThieu: (tien: string) => `Thiếu ${tien} so với sổ`,
  ketDu: (tien: string) => `Dư ${tien} so với sổ`,
  ketHoiLai: (tien: string) => `Chốt két với ${tien} đếm được? Chốt rồi không sửa được.`,
  ketChotThat: 'Chốt, không sửa nữa',
  demLai: 'Đếm lại',
  ketKhop: 'Khớp',
  ketLyDo: 'Lý do lệch (bắt buộc)',
  // KH-GĐ2 7.3.3: tiền để lại két → tiền đầu kỳ sau.
  ketGiuLai: 'Để lại trong két cho lần sau',
  ketGiuLaiGoiY: 'ví dụ 500.000',
  ketGiuLaiPhu: 'Tiền lẻ để thối cho khách. Để trống là rút hết.',
  ketGiuLaiQua: 'Không để lại nhiều hơn số đếm được.',
  ketDeLai: (tien: string) => `để lại ${tien}`,
  ketLyDoGoiY: 'ví dụ: thối nhầm cho khách',
  ketChot: 'Chốt két',
  ketDaChot: (lech: string) => `Đã chốt két · ${lech}`,
  ketLichSu: 'Các lần chốt',
  ketChuaChot: 'Chưa chốt lần nào.',
  ketDongLichSu: (canCo: string, dem: string) => `cần có ${canCo} · đếm ${dem}`,

  // Việc của tôi (KTV)
  navCuaToi: 'Việc của tôi',
  cuaToiTitle: 'Việc của tôi',
  homNayLam: 'Hôm nay',
  // Dưới tiêu đề "Hôm nay" — không lặp "Hôm nay" lần nữa (ui-critic vòng 47).
  chuaCoViec: 'Chưa có lịch nào của bạn.',
  hoaHongCuaToi: 'Hoa hồng tháng này',
  hoaHongGhiChu: 'Tính khi thu tiền xong. Hoá đơn bị huỷ thì trừ lại.',
  soKhachDaLam: (homNay: number, thang: number) =>
    `Đã làm cho ${homNay}\u00A0khách hôm nay · ${thang}\u00A0khách tháng này`,
  /** Hai cụm của `soKhachDaLam` cho `CacCum`; số dính với "khách" (không "0 / khách tháng này" — vòng 48). */
  soKhachDaLamCum: (homNay: number, thang: number): [string, string] => [
    `Đã làm cho ${homNay}\u00A0khách hôm nay`,
    `${thang}\u00A0khách tháng này`,
  ],
  tungDichVu: 'Từng dịch vụ tháng này',
  dongDao: 'trừ lại',
  // Tuần 1 phiên bản mới: thẻ khách "Các lần đến" (F05) + Báo cáo doanh thu (F09).
  lanDenTitle: 'Các lần đến',
  lanDenTrong: 'Khách chưa đến lần nào.',
  lanDenGoi: 'Trừ gói',
  tabBaoCao: 'Báo cáo',
  bcTitle: 'Báo cáo doanh thu',
  // Nhãn ngắn: chip chia 3 ô trên điện thoại không được bẻ dòng (ui-critic v23).
  bcTheoNgay: 'Ngày',
  bcTheoTho: 'Thợ',
  bcTheoDichVu: 'Dịch vụ',
  bcThang: (thang: string) => `Tháng ${thang.slice(5, 7)}/${thang.slice(0, 4)}`,
  bcThangTruoc: 'Tháng trước',
  bcThangSau: 'Tháng sau',
  // KH-GĐ2 5.4
  bcTai: (thang: string) => `Tải tệp tháng ${thang}`,
  bcTaiPhu: 'Mở bằng Excel. Mỗi dòng là một hoá đơn; không gồm tiền bo của thợ.',
  bcDaTai: 'Đã tải tệp về máy.',
  // Tổng hoá đơn gồm cả phần trả bằng ví (có tiền tặng) — không phải tiền vào két (RETRO 24/09, M6).
  bcTong: 'Doanh thu hoá đơn',
  bcSoHoaDon: (n: number) => `${n} hoá đơn`,
  bcGoi: (tien: string) => `làm bằng gói ${tien}`,
  bcTrong: 'Tháng này chưa có hoá đơn nào.',
  bcBanSanPham: 'Bán sản phẩm',
  bcKhongGhiTho: 'Chưa ghi thợ',
  bcKhac: 'Khác',
  // Sổ tiền theo chi nhánh (v0.24.3): số trên màn là của CẢ TIỆM; tiệm nhiều chi nhánh thì tách bên dưới.
  bcCaTiem: (n: number) => `Cả tiệm, gộp ${n} chi nhánh:`,
  bcDaNgung: ' (đã ngừng)',
  // Dấu hai chấm ngăn tên và tiền: tên kết thúc bằng số ("Quận 3") không bị đọc dính vào tiền (soát giao diện N-c).
  bcTachCn: (ten: string, tien: string) => `${ten}: ${tien}`,
  // Phần của thợ ở một chi nhánh chỉ làm bằng gói (tiền 0) hoặc có cả hai: "(gói 598.000đ)".
  bcGoiNgan: (tien: string) => `(gói ${tien})`,
  // Dòng phụ của từng chi nhánh ở chip Ngày: "12 hoá đơn · gói 299.000đ" (ngắn hơn "làm bằng gói …" để vừa 320px).
  bcGoiPhu: (tien: string) => `gói ${tien}`,
  soCaTiem: (n: number) => `Số của cả tiệm, gộp ${n} chi nhánh.`,
  soKetTungCn: 'Tiền mặt của từng chi nhánh xem ở thẻ Két.',
  trangThai: {
    booked: 'Đã đặt',
    checked_in: 'Khách đã tới',
    in_service: 'Đang làm',
    done: 'Xong',
    cancelled: 'Đã huỷ',
    no_show: 'Không đến',
  } as Record<string, string>,

  // Cấu hình: hoa hồng + bảng lương
  tabHoaHong: 'Hoa hồng',
  get hoaHongTitle() {
    return chuHienTai().hoaHongNhanVien
  },
  hoaHongHint: 'Buổi gói tính trên giá trị một buổi. Làm tròn xuống nghìn.',
  macDinh: 'Mức chung cho mọi dịch vụ (%)',
  mucRieng: 'Mức riêng (%)',
  rieng: 'Dịch vụ có mức riêng',
  themRieng: 'Thêm mức riêng',
  boRieng: 'Bỏ mức riêng',
  chonDichVu: 'Chọn dịch vụ',
  luuHoaHong: 'Lưu hoa hồng',
  // ADR-076 (KH-GĐ2 6.2.3)
  coSoHoaHong: 'Khách được giảm giá thì hoa hồng tính trên',
  truocGiam: 'Giá gốc',
  sauGiam: 'Giá đã giảm',
  truocGiamPhu:
    'Thợ nhận đủ hoa hồng dù khách được giảm — thợ không ngại làm cho khách dùng ưu đãi.',
  sauGiamPhu: 'Tiệm giảm bao nhiêu thì hoa hồng của thợ giảm theo.',
  daLuuHoaHong: 'Đã lưu hoa hồng. Hoa hồng đã tính trước đây giữ nguyên.',
  bangLuong: 'Bảng hoa hồng theo tháng',
  bangLuongHint: 'Chốt tháng đã qua để khoá số — chốt rồi không sửa được nữa.',
  thang: 'Tháng',
  chuaCoAi: 'Tháng này chưa có hoa hồng nào.',
  tongCong: 'Tổng cộng',
  chotThang: (t: string) => `Chốt tháng ${t}`,
  daChot: (luc: string, ai: string) => `Đã chốt ${luc}${ai === '' ? '' : ` bởi ${ai}`}`,
  daChotXong: (t: string) => `Đã chốt tháng ${t}`,
  thangDangChay: 'Tháng đang chạy — hết tháng mới chốt được.',
  thangTruoc: 'Tháng trước',
  thangSau: 'Tháng sau',
  nhanThang: (t: string) => `Tháng ${t}`,
  chotHoiLai: (t: string, tien: string) =>
    `Chốt tháng ${t} với tổng ${tien}? Chốt rồi không sửa được nữa.`,
  chotThat: 'Chốt, không sửa nữa',
  dvTienMat: 'Tại quầy · tiền mặt',
  dvChuyenKhoan: 'Tại quầy · chuyển khoản',
  dvThe: 'Tại quầy · quẹt thẻ',
} as const
